
define('app/board/models/positionColorsModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var PositionColorsModel = Backbone.Model.extend({	
		defaults: {
			id: null, //Just the lgInstId
	    },

	    initialize: function(models, options) {
	    	this.lgInstId = options.lgInstId;
	    	
	    	this.posDefaults = {};
	    	var lgPosCollection = options.lgPosCollection; //lgPosCollection
	    	lgPosCollection.each(function(lgPos) {
	    		for (var i = 0; i < lgPos.get('positions').length; i++) {
	    			var pos = lgPos.get('positions')[i];
	    			if(this.posDefaults[pos] == null || (lgPos.get('positions') && lgPos.get('positions').length == 1)){
	    				this.posDefaults[pos] = lgPos.get('color');
	    			}
				}
	    	}, this);
	    	
	    	this.set(this.posDefaults);
	    	
	    	this.posOverwrite = {};
	    	if(typeof localStorage !== 'undefined' && localStorage.getItem(this.lgInstId + ":posColorOverwrite")){
	    		this.posOverwrite = JSON.parse(localStorage.getItem(this.lgInstId + ":posColorOverwrite"));
	    		this.set(this.posOverwrite);
	    	}
	    	/*if(localStorage && localStorage.getItem("posColors")){
	    		var savedColors = JSON.parse(localStorage.getItem("posColors"));
	    		this.set(savedColors);
	    	}*/
	    	
	    	_.bindAll(this, 'saveLocalStorage');
	    	
	    	//this.listenTo(this, 'change', this.saveLocalStorage);
	    	//this.on('change', this.saveLocalStorage, this);
	    },
	    
	    changePosColor: function(pos, color) {
	    	this.posOverwrite[pos] = color;
	    	this.set(pos, color);
	    	
	    	//this.set(lgName.toLowerCase() + '_' + pos.toLowerCase(), color);
	    	
	    	this.saveLocalStorage();
	    },
	    
	    resetPosColor: function(pos) {
	    	var foundColor = this.posDefaults[pos];
	    	if(!foundColor) {
	    		foundColor =  '#FFFFFF'; 
	    	}
	    	
	    	delete this.posOverwrite[pos];
	    	this.set(pos, foundColor);
	    	
	    	this.saveLocalStorage();
	    },
	    
	    saveLocalStorage: function(){
	    	if(typeof localStorage !== 'undefined' && $.isLocalStorageSaveSupported()){
	    		localStorage.setItem(this.lgInstId + ":posColorOverwrite", JSON.stringify(this.posOverwrite));
	    		
	    		//var savedColors = this.toJSON();    		
	    		//localStorage.setItem("posColors", JSON.stringify(savedColors));
	    	}
	    },
	    
	    retrievePosColor: function(pos) {
	    	var foundColor = '';
	    	
	    	if(pos && this.get(pos)){
	    		foundColor =  this.get(pos);
	    		//return this.get(lgName.toLowerCase() + '_' + pos.toLowerCase());
	    	} else {
	    		foundColor =  '#FFFFFF';
	    	}
	    	
	    	if(foundColor.charAt(0) != "#"){
				foundColor = '#' + foundColor;
			}
	    	
	    	return foundColor;
	    } 
	});
	
	
	
	return PositionColorsModel;  
});